if (!customElements.get("pdp-icon-with-text")) {
  customElements.define(
    "pdp-icon-with-text",
    class PdpIconWithText extends HTMLElement {
      constructor() {
        super();

        const buttons = this.querySelectorAll(".js-item-button");
        buttons?.forEach((button) => {
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pdp-icon-with-text-drawer")
              .show(evt.target);
          });
        });
      }
    }
  );
}

if (!customElements.get("pdp-icon-with-text-drawer")) {
  customElements.define(
    "pdp-icon-with-text-drawer",
    class PdpIconWithTextDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });
        
        this.querySelector('.icon-with-text-overlay').addEventListener('click', () => {
          this.hide();
        });

        this.querySelectorAll(".js-item-tab").forEach(item => {
          item.addEventListener("click", (evt) => {
            this.tabEvent(evt);
          });
        })

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      tabEvent(evt) {
        let target = evt.target;
        let tabParent = target.closest(".js-item-tab");
        let dataTab = tabParent.dataset.tab;
        target.closest("pdp-icon-with-text-drawer").querySelectorAll(`.js-item-tab`).forEach(item => {
          item.classList.remove('active');
        })
        target.closest("pdp-icon-with-text-drawer").querySelectorAll(`.js-item-content`).forEach(item => {
          item.classList.remove('active');
        })
        target.closest("pdp-icon-with-text-drawer").querySelector(`.js-item-tab[data-tab="${dataTab}"]`).classList.add('active');
        target.closest("pdp-icon-with-text-drawer").querySelector(`.js-item-content[data-tab="${dataTab}"]`).classList.add('active');
      }

      handleBodyClick(evt) {
        const target = evt.target;

        if (
          target != this &&
          !target.closest("pdp-icon-with-text-drawer") &&
          !target.closest(".js-item-button")
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
      }

      show(focusElement) {
        //this.focusElement = focusElement;
        let dataBtn = focusElement.closest(".js-item-button").dataset.button;
        this.querySelectorAll(`.js-item-tab`).forEach(item => {
          item.classList.remove('active');
        })
        this.querySelectorAll(`.js-item-content`).forEach(item => {
          item.classList.remove('active');
        })
        this.querySelector(`.js-item-tab[data-tab="${dataBtn}"]`).classList.add('active');
        this.querySelector(`.js-item-content[data-tab="${dataBtn}"]`).classList.add('active');
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
      }
    }
  );
}
